import React from "react";
import { FormattedMessage } from "react-intl";

import { EMAIL_CLASSIFICATION_TYPE, EMAIL_TYPE } from "@utils/enum";

export const EMAIL_LABELS = {
  [EMAIL_TYPE.INCOMING]: <FormattedMessage id="label_received" />,
  [EMAIL_TYPE.OUTGOING]: <FormattedMessage id="label_sent" />,
};

export const IS_SECURE_EMAIL = {
  [1]: <FormattedMessage id="yes_label" />,
  [0]: <FormattedMessage id="no_label" />,
};

export const EMAIL_CLASSIFICATION = {
  [EMAIL_CLASSIFICATION_TYPE.AUTOMATIC_REPLY]: (
    <FormattedMessage id={EMAIL_CLASSIFICATION_TYPE.AUTOMATIC_REPLY} />
  ),
  [EMAIL_CLASSIFICATION_TYPE.NO_CRIMINAL_CASES]: (
    <FormattedMessage id={EMAIL_CLASSIFICATION_TYPE.NO_CRIMINAL_CASES} />
  ),
  [EMAIL_CLASSIFICATION_TYPE.HAS_CRIMINAL_CASES]: (
    <FormattedMessage id={EMAIL_CLASSIFICATION_TYPE.HAS_CRIMINAL_CASES} />
  ),
  [EMAIL_CLASSIFICATION_TYPE.SECURE_EMAIL]: (
    <FormattedMessage id={EMAIL_CLASSIFICATION_TYPE.SECURE_EMAIL} />
  ),
};
